var React = require('react');

function LogoTransparent (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"crane-path","d":"M53.1392 64L61.0155 56.3771M53.1392 64L51.9096 46.7213M53.1392 64L25.7975 53.8361M67.3165 50.2787L82 64L61.0155 56.3771M67.3165 50.2787L61.0155 56.3771M67.3165 50.2787L51.9096 46.7213M51.9096 46.7213L51.6202 42.6557L78.4557 2L47.0633 17.2459L42.5063 25.3771M25.7975 53.8361L22.2532 23.3443M25.7975 53.8361L42.5063 25.3771M22.2532 23.3443L2 20.8033L20.7342 10.1311M22.2532 23.3443L20.7342 10.1311M20.7342 10.1311L42.5063 25.3771M41.4937 30.459L44.5316 37.0656H52.6329M41.4937 30.459L38.4557 48.7541L52.6329 37.0656M41.4937 30.459L56.1772 17.2459L52.6329 37.0656M41.4937 30.459L50.1013 28.9344L52.6329 37.0656","stroke":"black"}));
}

LogoTransparent.defaultProps = {"width":"83","height":"65","viewBox":"0 0 83 65","fill":"none"};

module.exports = LogoTransparent;

LogoTransparent.default = LogoTransparent;
